/** Short, localised date, e.g. "28 सित॰ 2026" or "28 Sept 2026". */
export const formatDate = (value, lang = "hi") => {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "" :
    d.toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short", year: "numeric" });
};
